import { Flex } from '@chakra-ui/react';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const NotificationIndicator = () => {
  return (
    <Flex
      color="actionSecondaryCautionContent"
      marginStart={1}
    >
      <FontAwesomeIcon fontSize={8} icon={faCircle} />
    </Flex>
  );
};
